import { render } from "./AITaskAnalyzer.vue?vue&type=template&id=1bed5f59&scoped=true"
import script from "./AITaskAnalyzer.vue?vue&type=script&lang=js"
export * from "./AITaskAnalyzer.vue?vue&type=script&lang=js"

import "./AITaskAnalyzer.vue?vue&type=style&index=0&id=1bed5f59&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bed5f59"]])

export default __exports__